import { t } from '@lingui/core/macro'

import { IconColumns3 } from '@tabler/icons-react'
import { useCallback, useId } from 'react'
import { useDynamicTable } from '~/components/dynamic_table/context'

export default function VisibilityToggle() {
  const { state } = useDynamicTable()
  const { columns, setColumns } = state
  const dropdownId = useId()

  const isVisible = useCallback(
    (label) => {
      const col = columns.find((column) => column.label === label)
      return !(col.visible === false)
    },
    [columns],
  )

  return (
    <div className='visibility-toggle'>
      <button
        type='button'
        className='btn btn-sm btn-link dropdown-toggle border-0 text-muted'
        id={dropdownId}
        data-bs-toggle='dropdown'
        data-bs-auto-close='outside'
        aria-expanded='false'
        title={t`Columns`}
      >
        <IconColumns3 size={20} stroke={1} />
      </button>
      <ul className='dropdown-menu px-2 pt-2' aria-labelledby={dropdownId} data-testid='visibility-toggle-dropdown'>
        {columns.map(({ label }) => (
          <li key={label} className='form-check py-1'>
            <input
              className='form-check-input'
              type='checkbox'
              id={`column-${label}`}
              checked={isVisible(label)}
              onChange={() => {
                setColumns((prev) =>
                  prev.map((column) => (column.label === label ? { ...column, visible: !isVisible(label) } : column)),
                )
              }}
            />
            <label className='form-check-label text-uppercase' htmlFor={`column-${label}`} style={{ fontSize: '10px' }}>
              {label}
            </label>
          </li>
        ))}
      </ul>
    </div>
  )
}
